module.exports = __webpack_public_path__ + "img/icontouxiang2.134a646c.png";